<template>
    <Spin v-show="loading" fix class="spin">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>{{ $t('loginText') }}</div>
    </Spin>
</template>
<script>
import { mapState, mapActions } from "vuex";
import logger from '@/assets/log'
const log = logger("views:launch");

export default {
    data() {
        return {
            loading: false
        };
    },
    computed: mapState({
        status: state => state.user.status
    }),
    watch: {
        status() {
            if (this.status == "online") {
                this.$router.replace("/home");
            }
        }
    },
    created() {
        // 创建的时候不会调用watch
        if (this.status == "online") {
            this.$router.replace("/home");
        }
    },
    mounted() {
        setTimeout(() => {
            this.loading = true;
        }, 3000);
    }
};
</script>
